export interface IResaleBillingMetadata {
  isPropertyAddress: boolean;
  isContactAddress: boolean;
  isCobroke: boolean;
  isWithPayment: boolean;
  isBillToAll: boolean;
  isPC: boolean;
  isCounterparty: boolean;
}
